import { useMemo, useState } from "react";
import { MapPin, MessageCircle } from "lucide-react";
import PageHero from "@/components/PageHero";
import { PROJECTS, SITE } from "@/data/site";

const CATS = ["All", "Residential", "Commercial", "Infrastructure", "Interior Design"];

export default function Projects() {
  const [active, setActive] = useState("All");
  const list = useMemo(() => active === "All" ? PROJECTS : PROJECTS.filter(p => p.category === active), [active]);

  return (
    <div data-testid="projects-page">
      <PageHero
        eyebrow="Portfolio"
        title="Every project a landmark. Every landmark a story."
        subtitle="A curated selection of residential, commercial, infrastructure and interior projects across Ranchi, Bhubaneswar and Guwahati."
        image="/images/home.jpeg"
        crumbs={[{ label: "Home", to: "/" }, { label: "Projects" }]}
      />

      <section className="py-16 md:py-20 bg-[#F8F7F5]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap gap-2 md:gap-3 mb-12" data-testid="projects-filters">
            {CATS.map(c => (
              <button
                key={c}
                onClick={() => setActive(c)}
                data-testid={`filter-${c.replace(/\s+/g,'-').toLowerCase()}`}
                className={`px-5 py-2.5 text-sm tracking-wide border transition-colors ${active === c ? "bg-[#0B162C] text-white border-[#0B162C]" : "bg-white text-[#0B162C] border-[#E5E7EB] hover:border-[#C5A059] hover:text-[#C5A059]"}`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map((p, i) => (
              <article key={p.title} className="project-card bg-white h-[440px]" data-testid={`project-card-${i}`}>
                <img src={p.img} alt={p.title} className="w-full h-full object-cover"/>
                <div className="absolute inset-0 veil"></div>
                <div className="absolute inset-0 p-7 flex flex-col justify-between text-white">
                  <div className="flex items-center gap-2 self-start">
                    <span className="text-[10px] uppercase tracking-[0.28em] bg-[#C5A059] text-white px-2.5 py-1">{p.category}</span>
                  </div>
                  <div>
                    <h3 className="font-serif-display text-3xl leading-tight">{p.title}</h3>
                    <a
                      href={SITE.siteVisitHref(p.title)}
                      target="_blank" rel="noreferrer"
                      data-testid={`project-book-visit-${i}`}
                      className="mt-5 inline-flex items-center gap-2 bg-[#C5A059] hover:bg-[#A6864A] text-white text-sm font-medium tracking-wide px-5 py-2.5 transition-colors"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <MessageCircle size={14}/> Know More
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {list.length === 0 && (
            <div className="text-center text-[#5C6B7B] py-20" data-testid="projects-empty">No projects in this category yet.</div>
          )}
        </div>
      </section>
    </div>
  );
}
